<div class="page-container" *ngIf="formGroup">
  <form (ngSubmit)="searchPatients($event)">
    <span class="input-wrapper">
      <div class="form-part">
        <frg-form-input
          id="patientName"
          label="Nom d’usage ou nom de naissance"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('patientName')"
        ></frg-form-input>

        <frg-form-input
          id="patientFirstname"
          label="Prénom"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('patientFirstname')"
        ></frg-form-input>

        <frg-form-input
          id="sex"
          label="Sexe"
          type="ngSelect"
          [selectValue]="sexValues"
          [formGroup]="formGroup"
          [control]="formGroup.get('sex')"
        ></frg-form-input>
      </div>

      <div class="form-part">
        <frg-form-input
          id="birth"
          label="Date de naissance"
          type="date"
          [formGroup]="formGroup"
          [control]="formGroup.get('birth')"
        ></frg-form-input>

        <frg-form-input
          id="zip"
          label="Code postal"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('zip')"
        ></frg-form-input>

        <frg-form-input
          id="city"
          label="Ville"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('city')"
        ></frg-form-input>
      </div>
    </span>

    <frg-form-input
      id="approxNamePatient"
      label="Recherche étendue aux noms de patients approchants"
      type="checkbox"
      isCheckLabelAlign="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('approxNamePatient')"
    ></frg-form-input>

    <frg-form-input
      id="approxNameCity"
      label="Recherche étendue aux noms de villes approchantes"
      type="checkbox"
      isCheckLabelAlign="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('approxNameCity')"
    ></frg-form-input>

    <div class="button-wrapper">
      <frg-button (activated)="readVitale()">
        <div title="Lire la carte vitale du patient">Lecture carte vitale</div>
      </frg-button>
      <frg-button type="submit">
        <div title="Lancer la recherche de DMP">Rechercher</div>
      </frg-button>
    </div>
  </form>

  <div class="result-container" *ngIf="patientsTable && patientsTable.objects && patientsTable.objects.length > 0">
    <frg-table
      [keysBody]="patientsTable"
      [keysColumn]="patientsTableColumnTable"
      [isRowsClickable]="true"
      (onClickRow)="selectPatientInResultsList($event)"
    ></frg-table>
  </div>

  <div class="result-container no-patient" *ngIf="patientsTable && patientsTable.objects && patientsTable.objects.length === 0">
    Aucun patient trouvé
  </div>
</div>